function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenturyplayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lipx98vkea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8515",
    transform: "translate(1228 6390)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h173v173H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 161",
    transform: "translate(-1228 -6390)",
    style: {
      clipPath: "url(#lipx98vkea)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10383"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46338",
    d: "M12.289 43.906h-5.1V38.87c0-.41-.262-.616-.778-.616q-.824 0-.823.616v17.277c0 .416.274.617.823.617.516 0 .778-.2.778-.617v-6.318h5.1v6.5a3.3 3.3 0 0 1-1.8 2.923 7.448 7.448 0 0 1-4.011 1.088C2.151 60.34 0 58.813 0 55.753V39.725c0-3.317 2.151-4.974 6.478-4.974 3.868 0 5.812 1.5 5.812 4.531",
    transform: "translate(1237 6456.461)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46339",
    d: "M20.447 60.324H9.512V34.75h10.859v3.281H15.1v6.909h4.76v3.109H15.1v8.985h5.351",
    transform: "translate(1242.327 6456.461)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46340",
    d: "M32.4 60.324h-5.753L22.813 46.7v13.624h-4.662V34.75h6.368l3.235 11.66V34.75H32.4",
    transform: "translate(1247.165 6456.461)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46341",
    d: "M40.764 38.071h-3.122v22.252h-5.59V38.071H28.92v-3.322h11.844",
    transform: "translate(1253.195 6456.459)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46342",
    d: "M38.15 34.741h5.587v21.248c0 .519.321.774.938.774s.919-.255.919-.774V34.741h5.6v20.95a4.078 4.078 0 0 1-1.82 3.56 8.381 8.381 0 0 1-4.7 1.094 9.223 9.223 0 0 1-4.586-.971 3.91 3.91 0 0 1-1.939-3.627",
    transform: "translate(1258.364 6456.455)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46343",
    d: "M55.451 43.582v-4.207c0-.893-.565-1.343-1.7-1.343v6.908c1.134.001 1.7-.449 1.7-1.358zm6.4 16.779h-5.566c-.592-.729-.9-2.788-.9-6.175v-.044l.022-1.532.044-3.259c0-.867-.565-1.3-1.7-1.3v12.274h-5.607V34.751h6.9a7.6 7.6 0 0 1 4.106 1.084 3.748 3.748 0 0 1 1.75 3.44v3.069c0 1.973-1.152 3.328-3.473 4.02a4.007 4.007 0 0 1 3.473 4.229l-.076 2.8c.003 4.099.35 6.42 1.028 6.968z",
    transform: "translate(1263.961 6456.461)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46344",
    d: "m73.422 34.751-3.653 10.311-1.838 5.147v10.116h-5.6V50.4a35.84 35.84 0 0 0-1.431-5.3c-.743-2.218-1.8-5.67-3.226-10.352h5.346l2.514 9 2.857-9",
    transform: "translate(1269.3 6456.461)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46345",
    d: "M76.714 45.887v-6.14c0-.9-.621-1.345-1.852-1.345v8.839c1.231.001 1.852-.449 1.852-1.354zm-1.852 5v9.432h-5.454V34.75h5.871a11.689 11.689 0 0 1 5.2.887c1.124.591 1.686 1.808 1.686 3.638v7.088a4.167 4.167 0 0 1-1.386 3.561q-1.367 1.036-5.917.966z",
    transform: "translate(1275.869 6456.461)",
    style: {
      fill: "#ef4242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46346",
    d: "M89.685 60.324H79.216V34.75h5.6v22.283h4.869",
    transform: "translate(1281.361 6456.461)",
    style: {
      fill: "#ef4242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46347",
    d: "m100.589 34.751-3.664 10.311-1.825 5.147v10.116h-5.6V50.4a34.78 34.78 0 0 0-1.431-5.3q-1.094-3.327-3.221-10.352h5.34l2.52 9 2.855-9",
    transform: "translate(1284.514 6456.461)",
    style: {
      fill: "#ef4242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46348",
    d: "M98.967 34.2h-1.313v-1.53h1.457a1.181 1.181 0 0 1 .743.213.7.7 0 0 1 .237.541.613.613 0 0 1-.137.411.687.687 0 0 1-.347.28 2.194 2.194 0 0 1-.64.085zm.821.7a1.679 1.679 0 0 0-.365-.229 1.594 1.594 0 0 0 .971-.427 1.14 1.14 0 0 0 .312-.818 1.309 1.309 0 0 0-.189-.7 1.082 1.082 0 0 0-.5-.44 3.125 3.125 0 0 0-.93-.114h-2.028v4.582h.594v-2.032h.7a2.643 2.643 0 0 1 .35.023.77.77 0 0 1 .274.122 1.4 1.4 0 0 1 .309.3c.109.15.256.365.432.646l.606.942h.767l-.806-1.251a4.091 4.091 0 0 0-.496-.604zm-.841 2.9a3.2 3.2 0 1 1 3.185-3.2 3.2 3.2 0 0 1-3.184 3.2zm0-6.954a3.751 3.751 0 1 0 3.729 3.753 3.741 3.741 0 0 0-3.728-3.756z",
    transform: "translate(1290.323 6454.271)",
    style: {
      fill: "#100e0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46349",
    d: "M77.714 11.931 61.356 0 56.3 7.029l3.854 11.929h12.481zm-5.082 7.027-10.093 7.381 3.853 11.926 8.224 2.681 6.257-19.306zm-37.75-7.027 5.082 7.027h12.487L56.3 7.029 51.24 0zm21.4 18.957L46.2 38.255l3.851-11.917-10.09-7.38-8.251 2.682 6.263 19.306 8.218-2.677v8.673h20.216l-.019-8.677",
    transform: "translate(1254.757 6437)",
    style: {
      fill: "#ef4242"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenturyplayLogo);
export default __webpack_public_path__ + "static/media/centuryplay-logo.8323043019caaf5335e4eb8ad1ecc7ab.svg";
export { ForwardRef as ReactComponent };